module.exports = __webpack_public_path__ + "img/bk_16.ddb945d2.png";